export default __webpack_public_path__ + "static/media/twenty1.94344a08.jpg";